module.exports = __webpack_public_path__ + "media/components/page-header/static/mountain-badge--dark-6e1c3c1c6136d747a6cae2b55be8221c.svg";